import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import authSlice from "./auth-slice";
import siteAlertSlice from "./site-alert-slice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    siteAlert: siteAlertSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
